<template>
  <div
    class="gradient-bg absolute top-0 left-0 w-full h-full pointer-events-none"
  ></div>
</template>
